export type Bonus = {
  number: string
  title: string
  body: string
  /** URL pública de la portada. Vacío = se muestra una portada diseñada de respaldo. */
  cover: string
  accent: string
}

/**
 * Los 5 bonus reales del pack (DPS47 · Vivencia Ready, DPS47 - Bonus.docx).
 * Cuando estén los mockups, pegá la URL pública de cada uno en `cover`.
 */
export const bonuses: Bonus[] = [
  {
    number: '01',
    title: 'Printable Plan Cards',
    body: 'All 84 plans shrunk to one half-page card each: the arc in one line per moment, the three key cues and the closing question. Print it, fold it, keep it next to your speaker.',
    cover:
      'https://cdn.magicpatterns.com/uploads/xkWcvN5wa5EkLjqosDds2V/DPS47_-_Bono_1_-_Printable_Plan_Cards.png',
    accent: 'bg-ember',
  },
  {
    number: '02',
    title: 'Start Here: Your First Four Weeks',
    body: 'Tell it what kind of group you have — new, steady, mixed or fading — and it shows you exactly which four plans to run first, in which order, and what to watch for each week.',
    cover:
      'https://cdn.magicpatterns.com/uploads/wxHdkLoJAQvUktGoG3axLy/DPS47_-_Bono_2_-_Start_Here_-_Your_First_Four_Weeks.png',
    accent: 'bg-patrol-mustard',
  },
  {
    number: '03',
    title: 'See One Plan Run',
    body: 'Walk through one complete 90-minute class minute by minute: what the facilitator says, sees and decides, and why each moment comes where it does. Plus two detours for a tired or an over-lively group.',
    cover:
      'https://cdn.magicpatterns.com/uploads/8QeAKXVPkdV3aZncPRB9es/DPS47_-_Bono_3_-_See_One_Plan_Run.png',
    accent: 'bg-moss',
  },
  {
    number: '04',
    title: '52-Week Class Calendar',
    body: 'Weeks 5 to 52 already laid out in four quarters, with room for your workshops and breaks, in northern and southern hemisphere versions — so you never wonder what next Tuesday looks like.',
    cover:
      'https://cdn.magicpatterns.com/uploads/epJXVXdyftP2MPpMSnT11S/DPS47_-_Bono_4_-_52-Week_Class_Calendar.png',
    accent: 'bg-patrol-teal',
  },
  {
    number: '05',
    title: 'Arrive Ready: Your Pre-Class Reset',
    body: 'A short personal routine for the minutes before people arrive, plus a plan B if your sound fails, so you start the class calm instead of rushed.',
    cover:
      'https://cdn.magicpatterns.com/uploads/46zfK8YiwpHR7owXhMN28B/DPS47_-_Bono_5_-_Arrive_Ready_-_Your_Pre-Class_Reset.png',
    accent: 'bg-patrol-plum',
  },
]
